import { WorkflowFamily } from "../../../../../Core/Api/Types/workflow-family";
import TableSkeleton from "../../../../../Components/Table/TableSkeleton";
import { cacheService, workflowService } from "../../../../../Core/Api/services";
import IngestWorkflowTable from "../../../../../Components/Table/IngestWorkflowsTable/ingest-workflows-table";
import { useEffect, useState } from "react";
import { GridRowsProp } from "@mui/x-data-grid";
import { WorkflowProps } from "../../../../../Core/Api/Workflow/workflow-api-service";
import { useLocation, useNavigate } from "react-router";
import { routePaths } from "../../../../../Router/router";
import { PlatformMode } from "../../../../../Core/Api/Types/platform-mode";
import { WorkflowTag } from "../../../../../Core/Api/Types/workflow-tag";

export enum IngestStatus {
  Ready = "Ready",
  Created = "Created",
  PendingQC = "Pending QC",
  WaitingMezz = "Waiting for Mezz Reference",
  QcInProgress = "Quality Check in progress",
  Running = "Running",
  WorkflowError = "Workflow Error",
  Rejected = "Rejected",
  RejectedAuto = "RejectedAuto",
  Accepted = "Accepted",
  NeedCheckOrEdit = "Need check or editing",
  Completed = "Completed",
  Aborted = "Aborted",
  Deleted = "Deleted",
  MissingMetadata = "Missing Metadata",
  Cancelled = "Cancelled",
  Unknown = "Unknown",
}

function IngestProcessing() {
  const location = useLocation();
  const navigate = useNavigate();
  const platformMode = cacheService.GetPlatformMode();

  // Table rows
  const [rows, setRows] = useState<GridRowsProp>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtersData, setFiltersData] = useState<WorkflowProps["filtersData"]>({
    createdByNames: [],
    providersNames: [],
  });
  const [countInstances, setCountInstances] = useState<WorkflowProps["countInstances"]>({
    countInstancesAccepted: 0,
    countInstancesProcessing: 0,
    countInstancesPendingQC: 0,
    countInstancesRejected: 0,
    countInstancesError: 0,
    countInstancesWaitingMezz: 0,
    countInstancesQcInProgress: 0,
    countInstancesMissingMetadata: 0,
  });

  // Load data
  useEffect(() => {
    if (platformMode !== PlatformMode.Adam)
      workflowService.GetWorkflowsByFamily(WorkflowFamily.Ingest).then((data) => {
        setFiltersData(data.filtersData);
        setCountInstances(data.countInstances);
        setRows(data.rows);
        setIsLoading(false);
      });
    else {
      setIsLoading(true);

      let tag: WorkflowTag =
        location.pathname === routePaths.ingestAdamTrailers.path ? WorkflowTag.AdamTrailer : WorkflowTag.AdamSource;

      workflowService.GetWorkflowsByFamily(WorkflowFamily.Ingest, 7, tag).then((data) => {
        setFiltersData(data.filtersData);
        setCountInstances(data.countInstances);
        setRows(data.rows);
        setIsLoading(false);
      });
    }
  }, [platformMode, location.pathname]);

  useEffect(() => {
    if (platformMode !== PlatformMode.Adam && location.pathname !== routePaths.ingest.path)
      navigate(routePaths.ingest.path);
    if (platformMode === PlatformMode.Adam && location.pathname === routePaths.ingest.path)
      navigate(routePaths.ingestAdamSources.path);
  }, [location.pathname, platformMode]);

  return (
    <>
      <IngestWorkflowTable
        isLoading={isLoading}
        workflows={rows}
        filters={filtersData}
        instancesNumber={countInstances}
      />
    </>
  );
}

export default IngestProcessing;
